import topTitle from '@/components/title';
import { PREMIUMPLANCOLUMNS, ADDITIONALCOLUMNS, TERMSCOLUMNS } from './utils';
import { mainPlanDetail } from '@/views/insurance/insuranceManage/request';
import { downloadFileFun } from '@/utils/public';
import { streamInfo } from '@/views/organization/staffManage/request';
export default {
  components: {
    topTitle
  },
  data() {
    return {
      PREMIUMPLANCOLUMNS,
      ADDITIONALCOLUMNS,
      TERMSCOLUMNS,
      dataForm: null
    };
  },
  created() {
    mainPlanDetail({
      insurancePlanId: this.$route.params.id
    }).then(res => {
      console.log(res);
      this.dataForm = res;
    });
  },
  methods: {
    onPreview(val) {
      window.open(val.link);
    },
    async onDownload(obj) {
      // let fileData = await axios.get( obj.link, {responseType: 'blob'});
      // let URL = window.URL || window.webkitURL;
      // let downloadUrl = URL.createObjectURL(fileData.data);
      // let a = document.createElement('a');
      // a.href = downloadUrl;
      // a.download = obj.linkName;//下载后文件名
      // a.click();
      // a = null;
      // downloadUrl && URL.revokeObjectURL(downloadUrl);
      const arr = obj.linkName.split('.');
      const type = arr[arr.length - 1];
      const type2 = type == 'pdf' ? 'application/pdf' : type == 'png' ? 'image/png' : type == 'jpg' ? 'image/jpg' : type == 'jpeg' ? 'image/jpeg' : type == 'gif' ? 'image/gif' : type == 'jfif' ? 'image/jfif' : '';
      streamInfo({
        url: obj.link
      }).then(res => {
        downloadFileFun(res, type2, obj.linkName);
      });
    }
  }
};